import styled from "styled-components";
import { theme } from "ui";

export const BreadcrumbsContainer = styled.section`
  display: flex;
  align-items: center;
  gap: ${theme.space.x1};
`;

export const BreadcrumbsContentMobile = styled.section`
  display: flex;
  align-items: center;

  @media ${theme.device.desktopFirst.mobileXL} {
    a {
      padding-bottom: 0.25rem;
    }
  }
`;

export const DescriptionItemWrapper = styled.div``;

export const DescriptionItemWrapperLink = styled.div``;

export const DescriptionItem = styled.span`
  font-size: 1.15rem;
  color: ${theme.colors.neutral["400"]};
  text-align: center;
  font-weight: 400;
`;

export const SeparatorIcon = styled.span``;
